import type { EpocusRole } from "elephant-web/gql";
import { CAPABILITIES, type Capability } from "./capabilities";
import { useEpocusRole } from "./epocus-claim";

/**
 * The sanctioned way to check a role in ePOCUS UI code. Returns whether the
 * current user holds `capability`, per the canonical table in `capabilities.ts`.
 * Prefer this (and `<RoleGate>`) over inline role comparisons.
 */
export const useCan = (capability: Capability): boolean => {
  const role = useEpocusRole();
  const allowedRoles: readonly EpocusRole[] = CAPABILITIES[capability];
  return role !== null && allowedRoles.includes(role);
};
